import {roundToDecimal} from '../../../pages/netZero/constants/commonFunctions';

import {formatIndian} from './../../../utils/formatIndian';

const sumTableValue = (
  array: any[],
  key: string = 'value',
  withFormat: boolean = true
): string | number => {
  const total = array?.reduce((accumulator, currentValue) => {
    return accumulator + currentValue[key];
  }, 0);

  return withFormat
    ? formatIndian(roundToDecimal(total))
    : roundToDecimal(total);
};

export default sumTableValue;
